/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import { Component } from 'react';
import PropTypes from 'prop-types';
import { NavMarker } from 'react-rhumb';
import { connect } from 'react-redux';
import { stringify } from 'hub-http/helpers/params';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import HubSpotOnlyAppCookieLogin from 'Nabisco/app/HubSpotOnlyAppCookieLogin';
import LoginForm from './LoginForm';
import LoginLoading from '../shared/LoginLoading';
import BypassLoginDao from '../../data/BypassLoginDao';
import GoogleLoginDao from '../../data/GoogleLoginDao';
import { checkCookiesAndCsrf, extractRedirectQueryParams } from '../../lib/LoginUtils';
import googleLoginNonce from '../../lib/googleLoginNonce';
import LoginFailureHandlerFactory from '../../lib/LoginFailureHandlerFactory';
import SsoRequiredAuthStatuses from '../../constants/SsoRequiredAuthStatuses';
import TwoFactorAuthStatuses from '../../constants/TwoFactorAuthStatuses';
import ConfirmToLoginStatuses from '../../constants/ConfirmToLoginAuthStatuses';
import { SMART_LOGIN_COOKIE, SMART_LOGIN_REDIRECT } from '../../constants/SmartLogin';
import { setTwoFactorMethod as setTwoFactorMethodAction, setCredentials } from '../../actions';
import { parse as parseQuery } from 'hub-http/helpers/params';
import LoginDao from '../../data/LoginDao';
import { getIsInvalidTokenAlertVisible } from '../../selectors/TwoFactorAuth';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import { getCookie } from 'hub-http/helpers/cookies';
import { checkSafeOpener } from '../../utils/checkSafeOpener';
import { jsx as _jsx } from "react/jsx-runtime";
const STATE = {
  LOGIN: 0,
  BYPASSING_LOGIN: 1
};
const loginDao = new LoginDao();
const appCookieLogin = new HubSpotOnlyAppCookieLogin({
  loginRequest: loginDao.uiLogin.bind(loginDao),
  passThroughFallback: true
});
const bypassLoginDao = new BypassLoginDao();
const googleLoginDao = new GoogleLoginDao();
class LoginLanding extends Component {
  constructor(props) {
    super(props);
    const {
      search
    } = this.props.location;
    const query = parseQuery(search.substr(1));
    const redirectQueryParams = extractRedirectQueryParams(query);
    const {
      autoRedirectGoogle,
      loginPortalId
    } = redirectQueryParams;
    const {
      allowFbSignup,
      bypass,
      ignoreSsoRequired,
      page_id,
      signupParams,
      isOutlook
    } = query;
    let loginRedirectUrl = redirectQueryParams.loginRedirectUrl;
    if (allowFbSignup && page_id) {
      loginRedirectUrl = `${loginRedirectUrl}&page_id=${page_id}`;
    }
    const skipBypass = bypass === 'false';
    const renderState = autoRedirectGoogle || loginPortalId && !skipBypass ? STATE.BYPASSING_LOGIN : STATE.LOGIN;
    this.state = {
      autoRedirectGoogle,
      ignoreSsoRequired: ignoreSsoRequired === 'true' || false,
      renderState,
      loginPortalId,
      loginRedirectUrl,
      signupParams,
      skipBypass,
      isOutlook,
      googleLoginRedirectUrl: undefined // todo: assign or delete
    };
    this.renderLogin = this.renderLogin.bind(this);
    this.loginSubmit = this.loginSubmit.bind(this);
    this.twoFactorOrRedirectOnSuccess = this.twoFactorOrRedirectOnSuccess.bind(this);
    this.confirmToLoginOrGenericError = this.confirmToLoginOrGenericError.bind(this);
    this.googleLoginClick = this.googleLoginClick.bind(this);
    this.ssoLoginClick = this.ssoLoginClick.bind(this);
    this.__renderStatesCached = this.renderStates();
  }
  componentDidMount() {
    const {
      autoRedirectGoogle,
      loginPortalId,
      loginRedirectUrl,
      skipBypass,
      isOutlook
    } = this.state;
    checkSafeOpener({
      loginRedirectUrl
    });
    const loginRenderState = () => {
      this.setState({
        renderState: STATE.LOGIN
      });
      if (!isOutlook) {
        this.redirectOnSmartLoginCookie();
      }
    };
    if (autoRedirectGoogle) {
      this.googleLoginClick(loginRenderState);
      return;
    }
    appCookieLogin.loginPrep();
    if (loginPortalId && !skipBypass) {
      const transitionToSsoRequired = () => {
        const nextPath = `/sso?${stringify({
          loginPortalId,
          loginRedirectUrl,
          required: true
        })}`;
        this.props.history.push(nextPath);
      };
      const isRedirectingToJita = redirectUrl => {
        return redirectUrl.indexOf('login/jita') !== -1;
      };
      const checkCookiesAndCsrfAndRedirect = (loginPortalIdForCookies, redirectUrl) => {
        if (isRedirectingToJita(redirectUrl)) {
          window.location.href = redirectUrl; // Safe usage of window.location assignment. This comes back from login service, which checks safety.
          return Promise.resolve();
        }
        return checkCookiesAndCsrf(loginPortalIdForCookies).then(() => {
          window.location.href = redirectUrl; // Safe usage of window.location assignment. This comes back from login service, which checks safety.
        }).catch(() => {
          console.log('Failed checking for csrf cookies, clearing redirectUrl query params');
          loginRenderState();
          const nextPath = `?${stringify({
            loginPortalId
          })}`;
          this.props.history.push(nextPath);
        });
      };
      const ssoRequiredOrBypass = response => {
        if (response.status && response.status === SsoRequiredAuthStatuses.SSO_LOGIN_REQUIRED) {
          return transitionToSsoRequired();
        }
        return checkCookiesAndCsrfAndRedirect(loginPortalId, response.redirectUrl);
      };
      bypassLoginDao.bypass({
        loginPortalId,
        loginRedirectUrl
      }).then(ssoRequiredOrBypass, loginRenderState);
    } else if (!isOutlook) {
      this.redirectOnSmartLoginCookie();
    }
  }
  redirectOnSmartLoginCookie() {
    const hasCookie = getCookie(SMART_LOGIN_COOKIE, document.cookie);
    const hasATCookie = getCookie('hs_selenium', document.cookie);
    if (hasCookie && !hasATCookie) {
      const nextPath = `${SMART_LOGIN_REDIRECT}${stringify(window.location.search)}`;
      this.props.history.push(nextPath);
    }
  }
  twoFactorOrRedirectOnSuccess(responses) {
    const {
      setTwoFactorMethod
    } = this.props;
    const {
      googleLoginRedirectUrl,
      loginPortalId,
      loginRedirectUrl
    } = this.state;
    const response = responses[0];
    if (response.status === TwoFactorAuthStatuses.TWO_FACTOR_REQUIRED) {
      const {
        token,
        primary,
        secondary,
        backupCodesEnabled
      } = response;
      setTwoFactorMethod(token, primary, secondary, backupCodesEnabled);
      const nextPath = `/two-factor?${stringify({
        googleLoginRedirectUrl,
        loginPortalId,
        loginRedirectUrl
      })}`;
      this.props.history.push(nextPath);
    } else if (response.status === SsoRequiredAuthStatuses.SSO_LOGIN_REQUIRED) {
      const {
        hubId,
        requiredBy
      } = response;
      const nextPath = `/sso?${stringify({
        loginPortalId: hubId,
        required: true,
        requiredBy,
        loginRedirectUrl
      })}`;
      this.props.history.push(nextPath);
    } else if (response.status === ConfirmToLoginStatuses.SUSPICIOUS_USER_MUST_CONFIRM) {
      const {
        token,
        email,
        rememberLogin
      } = response;
      setTwoFactorMethod(token, null, null, false);
      this.props.setCredentials({
        token,
        email,
        rememberLogin
      });
      const nextPath = `/confirm-to-login?${stringify({
        loginRedirectUrl,
        loginPortalId
      })}`;
      this.props.history.push(nextPath);
    } else {
      appCookieLogin.redirectOnLoginSuccess(responses);
    }
  }
  confirmToLoginOrGenericError(response, triggerReset) {
    const {
      loginRedirectUrl,
      loginPortalId
    } = this.state;
    if (response.responseJSON && response.responseJSON.status === ConfirmToLoginStatuses.SUSPICIOUS_USER_MUST_CONFIRM) {
      const nextPath = `/confirm-to-login?${stringify({
        loginRedirectUrl,
        loginPortalId
      })}`;
      this.props.history.push(nextPath);
      return Promise.resolve();
    } else {
      return LoginFailureHandlerFactory.create(triggerReset, this.props.history.push)(response);
    }
  }
  loginSubmit(credentials, triggerReset) {
    const {
      loginPortalId,
      loginRedirectUrl
    } = this.state;
    const credentialParams = Object.assign({}, credentials, {
      loginPortalId,
      loginRedirectUrl
    });
    this.props.setCredentials(credentialParams);
    appCookieLogin.login(credentialParams).then(this.twoFactorOrRedirectOnSuccess).catch(response => this.confirmToLoginOrGenericError(response, triggerReset));
  }
  googleLoginClick(triggerReset) {
    const {
      loginPortalId,
      loginRedirectUrl
    } = this.state;
    const credentials = {
      loginPortalId,
      loginRedirectUrl
    };
    googleLoginDao.initialize(credentials).then(googleLoginNonce.storeAndRedirect).catch(LoginFailureHandlerFactory.createRavenReporter('Google initialization failed', triggerReset, this.props.history.push));
  }
  ssoLoginClick(email) {
    const {
      loginPortalId,
      loginRedirectUrl
    } = this.state;
    const params = {
      loginPortalId,
      loginRedirectUrl
    };
    if (email && email !== '') {
      params.email = email;
    }
    const nextPath = `/sso?${stringify(params)}`;
    this.props.history.push(nextPath);
  }
  renderStates() {
    return {
      [STATE.LOGIN]: this.renderLogin,
      [STATE.BYPASSING_LOGIN]: this.renderBypassingLogin
    };
  }
  renderLogin() {
    const {
      isInvalidTokenAlertVisible
    } = this.props;
    const {
      loginRedirectUrl,
      signupParams
    } = this.state;
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "LOGIN_LOAD",
      children: /*#__PURE__*/_jsx(LoginForm
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ onLoginSubmit: (credentials: Credentials, ... Remove this comment to see the full error message
      , {
        onLoginSubmit: this.loginSubmit,
        onGoogleLoginClick: this.googleLoginClick,
        onSsoLoginClick: this.ssoLoginClick,
        isInvalidTokenAlertVisible: isInvalidTokenAlertVisible,
        loginRedirectUrl: loginRedirectUrl,
        signupParams: signupParams
      })
    });
  }
  renderBypassingLogin() {
    return /*#__PURE__*/_jsx(LoginLoading, {});
  }
  render() {
    const {
      renderState
    } = this.state;
    const renderFunction = this.__renderStatesCached[renderState];
    if (renderFunction) {
      return renderFunction();
    } else {
      console.error(`Unknown landing state ${renderState}. Cannot render.`);
      return null;
    }
  }
}
LoginLanding.propTypes = {
  location: PropTypes.object.isRequired,
  isInvalidTokenAlertVisible: PropTypes.bool.isRequired,
  setTwoFactorMethod: PropTypes.func.isRequired,
  setCredentials: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};
const reduxConnect = connect(state => ({
  isInvalidTokenAlertVisible: getIsInvalidTokenAlertVisible(state)
}), {
  setCredentials,
  setTwoFactorMethod: setTwoFactorMethodAction
});

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof ConfirmToLoginPage' is no... Remove this comment to see the full error message
export default reduxConnect(LoginLanding);